export default "__VITE_ASSET__4HfwWSdU__"